import { useQuery } from '@tanstack/react-query';

import { IncidentClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const incidentClient = new IncidentClient(apiBaseUrl);

interface FindIncidentProps {
  eventDate: string;
  flightNumber: string;
  aircraftNumber: string;
}

function useFindIncident({ eventDate, flightNumber, aircraftNumber }: FindIncidentProps) {
  return useQuery({
    queryKey: [queryKeys.Incident.Find, { aircraftNumber, eventDate, flightNumber }],
    queryFn: () => incidentClient.findIncident(eventDate, flightNumber, aircraftNumber),
    enabled: false,
  });
}

export default useFindIncident;
